import axios from '../../../../utills/axiosConfig';

export const fetchDepartmentGroups = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/department-groups', { params });
  return res.data;
};

export const addDepartmentGroup = async (departmentGroup) => {
  try {
    const res = await axios.post('/department-groups', departmentGroup);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateDepartmentGroup = async (id, departmentGroup) => {
  const res = await axios.put(`/department-groups/${id}`, departmentGroup);
  return res.data;
};

export const deleteDepartmentGroup = async (id) => {
  const res = await axios.delete(`/department-groups/${id}`);
  return res.data;
};

export const importDepartmentGroupCSV = async (formData) => {
  const { data } = await axios.post('/department-groups/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 